import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { KeyWarningComponent } from "./key-warning.component";

@Injectable({ providedIn: "root" })
export class KeyWarningModalService {
	constructor(private modalController: ModalController) {}

	showWarningForKey = async (location: string): Promise<string> => {
		const top = await this.modalController.getTop();
		if (top?.id === KeyWarningComponent.modalId) {
			return "";
		}

		const modal = await this.modalController.create({
			id: KeyWarningComponent.modalId,
			cssClass: "key-warning-modal",
			component: KeyWarningComponent,
			backdropDismiss: false,
			componentProps: {
				location,
			},
		});

		await modal.present();
		const response = await modal.onDidDismiss<string>();
		return response.data;
	};

	CloseKeyWarningIfShown = async () => {
		const top = await this.modalController.getTop();
		if (top?.id === KeyWarningComponent.modalId) {
			top.dismiss();
		}
	};
}
